import { render, staticRenderFns } from "./GeneralConditionsSale.vue?vue&type=template&id=68cad34d&scoped=true&"
import script from "./GeneralConditionsSale.vue?vue&type=script&lang=js&"
export * from "./GeneralConditionsSale.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConditionsSale.vue?vue&type=style&index=0&id=68cad34d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cad34d",
  null
  
)

export default component.exports